import { defineStore, acceptHMRUpdate } from 'pinia'
import { SYSTEM } from '~~/enum'

type SystemState = {
  info: {
    language?: string
    country?: string
    appVersion?: number
    safeTop: number
    navBarH: number
    bottomSafeH: number
    systemType?: string
  }
  transition: string
  // 是否在app内
  isGWM: boolean
  isAndroid: boolean
  // 平台
  channel: string
}
/**
 * 城市选择器数据存储
 */
const defaultSystemState = {
  info: {
    language: 'en_US',
    country: 'AU',
    appVersion: 0,
    safeTop: 0,
    navBarH: 0,
    bottomSafeH: 0,
    systemType: '',
  },
  transition: '',
  // 是否在app内
  isGWM: false,
  isAndroid: true,
  // 平台
  channel: 'APP',
}

const systemStore = defineStore('systemStoreW', {
  state: (): SystemState => defaultSystemState,
  actions: {
    SET_TRANSITION(payload: string) {
      this.transition = payload
    },
    SET_INFO(payload: PartialNull<SystemState['info']>) {
      const { appVersion, navBarH, safeTop, bottomSafeH, language, country, systemType } = payload
      this.info = {
        appVersion: Number(appVersion) ? Number(appVersion) : 0,
        navBarH: Number(navBarH) ? Number(navBarH) : 44,
        safeTop: Number(safeTop) ? Number(safeTop) : 0,
        bottomSafeH: Number(bottomSafeH) ? Number(bottomSafeH) : 0,
        language: language || 'en_US',
        country: country || 'AU',
        systemType: systemType || '1',
      }
    },
    SET_IS_GEM(payload: boolean) {
      this.isGWM = payload
    },
    SET_LANG(payload: string) {
      this.info.language = payload
    },
    SET_IS_ANDROID(payload?: string | null) {
      this.isAndroid = payload === SYSTEM.ANDROID
    },
  },
})

export default systemStore

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(systemStore, import.meta.hot))
}
